import { render, staticRenderFns } from "./CreateBasketFormPopup.vue?vue&type=template&id=6fe4091c"
import script from "./CreateBasketFormPopup.vue?vue&type=script&lang=js"
export * from "./CreateBasketFormPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports